import { CommonModule as AngularCommon } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ArrowComponent } from './arrow/arrow.component';
// import { TAPArrowComponent } from './arrow/arrow.tap.component';
// import { FooterFallbackComponent } from './footer/footer-fallback/footer-fallback.component';
import { FooterComponent } from './footer/footer.component';
// import { TAPFooterComponent } from './footer/footer.tap.component';
import { HeaderModule } from './header/header.module';
import { InputsModule } from './inputs/inputs.module';
// import { ModalComponent } from './modal/modal.component';
import { MultitabModule } from './multitab/multitab.module';
// import { NotificationComponent } from './notification/notification.component';
import { INDRANotificationComponent } from './notification/notification.indra.component';
import { SegmentedControlRadioModule } from './segmented-control-radio/segmented-control-radio.module';
import { SidebarModule } from './sidebar/sidebar.module';
import { SlideshowComponent } from './slideshow/slideshow.component';
import { StickyNavbarModule } from './sticky-navbar/sticky-navbar.module';
import { SVGModule } from './svg/svg.module';
import { ToastComponent } from './toast/toast.component';
import { AlertLabelComponent } from './alert-label/alert-label.component';
import { LowestFareComponent } from './lowest-fare/lowest-fare.component';

import { IBEAdminModule } from '@ibe.components/shared/ibe-admin.module';

/* REPLICATED FILES */
import { INDRAModalComponent } from './modal/modal.indra.component';
import { TAPArrowComponent } from './arrow/arrow.indra.component';
import { INDRAFooterComponent } from './footer/footer.indra.component';
import { INDRAFooterFallbackComponent } from './footer/footer-fallback/footer-fallback.indra.component';
import { INDRASlideshowComponent } from './slideshow/slideshow.indra.component';
import { AnimationsModule } from '@ibe.animations/animations.module';


@NgModule({
	imports: [
		AngularCommon,
		HeaderModule,
		SVGModule,
		InputsModule,
		SidebarModule,
		MultitabModule,
		SegmentedControlRadioModule,
		StickyNavbarModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		IBEAdminModule,
		AnimationsModule		
	],
	declarations: [
		FooterComponent,
		INDRAFooterComponent,
		ArrowComponent,
		TAPArrowComponent,
		// ModalComponent,
		INDRAModalComponent,
		ToastComponent,
		// NotificationComponent
		INDRANotificationComponent,
		SlideshowComponent,
		INDRAFooterFallbackComponent,
		AlertLabelComponent,
		LowestFareComponent,
		INDRASlideshowComponent
	],
	exports: [
		SVGModule,
		InputsModule,
		SegmentedControlRadioModule,
		HeaderModule,
		SidebarModule,
		TAPArrowComponent,
		MultitabModule,
		StickyNavbarModule,
		INDRAFooterComponent,
		// ModalComponent,
		INDRAModalComponent,
		ToastComponent,
		// NotificationComponent
		INDRANotificationComponent,
		SlideshowComponent,
		FormsModule,
		ReactiveFormsModule,
		AlertLabelComponent,
		LowestFareComponent,
		IBEAdminModule,
		INDRASlideshowComponent, 
		AnimationsModule		
	],
	entryComponents: [ SlideshowComponent, INDRAModalComponent, INDRASlideshowComponent ]
})
export class TAPCommonModule { }
